import type { ExpenseCategory, PaymentMethod } from '@/types';

export const CATEGORY_LABEL: Record<ExpenseCategory, string> = {
  infrastructure: 'Infrastructure',
  software: 'Software',
  professional: 'Professional fees',
  marketing: 'Marketing',
  travel: 'Travel',
  equipment: 'Equipment',
  office: 'Office',
  bank_charges: 'Bank charges',
  tax: 'Tax',
  other: 'Other',
};

export const CATEGORY_LIST = Object.keys(CATEGORY_LABEL) as ExpenseCategory[];

export const METHOD_LABEL: Record<PaymentMethod, string> = {
  bank_transfer: 'Bank transfer',
  cash: 'Cash',
  cheque: 'Cheque',
  card: 'Card',
  mobile: 'Mobile money',
  other: 'Other',
};

export const METHOD_LIST = Object.keys(METHOD_LABEL) as PaymentMethod[];
